import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useEventosStore } from "../store/eventosStore";
import { useGeneralAppStore } from "../store/generalAppStore";
import { axios } from "../utils/axios";

const useEventos = () => {
  const { handlerLoading, handlerModal } = useGeneralAppStore();
  const {
    setLogsName,
    logNameSelect,
    setUserActivity,
    setErrorActivity,
    addEvents,
    addNewEvents,
    addEventosActa,
    setDetalleEvent,
    addTotalEvents,
    setIsLoad,
  } = useEventosStore();

  //TRAE LAS ULTIMAS 500 ACTIVIDADES
  const getActividadGeneral = async () => {
    handlerLoading({ loading: true, loadName: "eventos" });
    const response = await axios().get("/actividad_general");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setLogsName(data.log_names);
        setUserActivity(data.user_activity);
        setErrorActivity(data.error_activity);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "eventos" });
  };

  //PARA RECARGAR LOS REGISTROS CON NUEVOS EVENTOS
  const reloadAEvents = async (dataSend) => {
    const response = await axios().post("reload_actividad", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        addEvents(data, logNameSelect);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
  };

  //PARA TRAER DATOS D EUN REGISTRO
  const getEventSelect = async (id) => {
    handlerLoading({ loading: true, loadName: "detalle-evento" });
    const response = await axios().get(`actividad/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        handlerModal({ modal: true, modalName: "detalle-evento" });
        setDetalleEvent(data);
      }

      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un problema en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "detalle-evento" });
  };

  const getSelectedAudits = async (values) => {
    if (!values.subject_type && !values.log_name) return null;

    handlerLoading({ loading: true, loadName: "audits" });
    const response = await axios().post("audit", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setIsLoad(true);
        data.length > 0 && addNewEvents(data, values.log_name, values.subject_type);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "audits" });
  };

  const getErrorLogs = async (values) => {
    if (!values.log_name && values.log_name !== "error") return null;

    handlerLoading({ loading: true, loadName: "audits" });
    const response = await axios().post("audit", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setIsLoad(true);
        data.length > 0 && addNewEvents(data, values.log_name, values.subject_type);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "audits" });
  };

  const reloadAudits = async (values) => {
    const response = await axios().post("reload_audit", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        data.length > 0 && addNewEvents(data, values.log_name, values.subject_type);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
  };

  const auditActa = async (values) => {
    handlerLoading({ loading: true, loadName: "audit_acta" });
    const response = await axios().post("audit_acta", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        data.length > 0 && addEventosActa(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "audit_acta" });
  };

  const getActaAudits = async (values) => {
    if (!values.subject_type && !values.log_name) return null;

    handlerLoading({ loading: true, loadName: "audits_totales" });
    const response = await axios().post("logs_acta", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        if (data.length > 0) {
          if (values?.setEventos) {
            values?.setEventos(data);
          } else {
            addTotalEvents(data);
          }
        }
        // data.length > 0 && addTotalEvents(data);
        // if (data.length > 0 && setEventos) {
        //   setEventos(data);
        // }
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "audits_totales" });
  };

  const getUsuarioAudits = async (values) => {
    if (!values.subject_type && !values.log_name) return null;

    handlerLoading({ loading: true, loadName: "audits_totales" });
    const response = await axios().post("logs_usuario", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        data.length > 0 && addTotalEvents(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "audits_totales" });
  };

  return {
    getActividadGeneral,
    getErrorLogs,
    getEventSelect,
    getSelectedAudits,
    reloadAEvents,
    reloadAudits,
    auditActa,
    getActaAudits,
    getUsuarioAudits,
  };
};

export default useEventos;
